import { useEffect, useState } from 'react';
import { getSiteConfig } from '../api/utils/api/siteConfigApi';
import {
  SITE_CONFIG_KEY,
  SiteConfigMap,
} from '../constants/types/site-config-type';

/**
 * 사이트 설정(연혁, 지표 등)을 키 단위로 조회하는 훅
 * 조회 실패 시 빈 맵을 유지하므로 화면에서 기본값으로 폴백한다.
 *
 * 소비처가 한 곳인 키는 이 훅을 직접 쓰고, 폴백은 그 파일에 둔다.
 * 소비처가 여러 곳인 키(cs_info)는 전용 훅이 조회와 폴백을 함께 담당하므로 이 훅을 직접 쓰지 말고 아래 전용 훅을 사용한다.
 * - CS_INFO: useCsInfo (훅 밖에서는 toCsInfo)
 *
 * @param keys 조회할 설정 키 (최대 30개)
 */
export const useSiteConfig = (keys: SITE_CONFIG_KEY[]) => {
  const [configs, setConfigs] = useState<SiteConfigMap>({});
  const [loading, setLoading] = useState(true);
  // 배열 리터럴을 매 렌더 새로 받아도 재요청하지 않도록 문자열로 비교
  const keyParam = keys.join(',');

  useEffect(() => {
    let alive = true;

    getSiteConfig(keyParam.split(',') as SITE_CONFIG_KEY[])
      .then((data) => {
        if (alive) setConfigs(data);
      })
      .catch((err) => console.error('사이트 설정 조회 실패', err))
      .finally(() => {
        if (alive) setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, [keyParam]);

  return { configs, loading };
};
